import { findSelector, resource } from "data/helpers/apiv3";
import { PointOfInterest } from "data/records";

const [api, actions] = resource(PointOfInterest, []);

const selectors = {
  ...findSelector(PointOfInterest),
};

const reducers = {};

const initialState = {};

export {
  api as pointOfInterestApi,
  actions as pointOfInterestActions,
  selectors as pointOfInterestSelectors,
  reducers as pointOfInterestReducers,
  initialState as pointOfInterestInitialState,
};
